import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Hero() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleCategoryClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    setIsDropdownOpen(false);
  };

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20bright%20airy%20retail%20space%20with%20minimal%20product%20displays%20on%20floating%20shelves%2C%20natural%20daylight%20streaming%20through%20large%20windows%2C%20clean%20architectural%20lines%2C%20warm%20neutral%20interior%20with%20terrazzo%20flooring%2C%20contemporary%20Scandinavian%20design%2C%20editorial%20photography&width=1600&height=900&seq=hero-lifestyle-v3&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/35"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-32 md:py-0">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-20">
          <div className="flex-1 text-center lg:text-left pt-12 lg:pt-20">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-background-50 leading-tight mb-6">
              Hipobuy Spreadsheet
              <br />
              <span className="text-background-50/80">The Ultimate</span>
              <br />
              <span className="text-background-50/70">Product Research Guide 2026</span>
            </h1>

            <p className="text-background-50/80 text-base md:text-lg max-w-xl mb-8">
              Discover the latest Hipobuy Spreadsheet resources, product collections, buying guides, comparisons and safety tips. Find organized product information faster and make smarter shopping decisions.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 mb-8">
              <div className="relative">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center space-x-2 px-7 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap"
                >
                  <span>Explore Categories</span>
                  <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-sm"></i>
                  </span>
                </button>

                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-background-50 rounded-lg border border-background-200/70 py-2 max-h-80 overflow-y-auto z-20">
                    {categories.map((cat) => (
                      <button
                        key={cat.name}
                        onClick={() => handleCategoryClick(cat.url)}
                        className="w-full text-left px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors flex items-center space-x-3"
                      >
                        <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                          <i className={`${cat.icon} text-sm`}></i>
                        </span>
                        <span>{cat.name}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3.5 rounded-full border-2 border-background-50 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <span className="text-xs text-background-50/60 flex items-center space-x-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </span>
                Updated 2026 Resources
              </span>
              <span className="text-xs text-background-50/60 flex items-center space-x-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </span>
                Beginner Friendly
              </span>
              <span className="text-xs text-background-50/60 flex items-center space-x-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </span>
                Product Research Guide
              </span>
              <span className="text-xs text-background-50/60 flex items-center space-x-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </span>
                Safety Information
              </span>
            </div>

            <div className="mt-10">
              <Link
                to="/hipobuy-spreadsheet-guide"
                className="inline-flex items-center space-x-2 text-background-50/70 hover:text-background-50 text-sm transition-colors"
              >
                <span>Read the Complete Guide</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 md:bottom-12 left-0 right-0 text-center pointer-events-none">
        <div className="font-heading text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-background-50/10 tracking-tighter leading-none select-none">
          SMARTER SHOPPING STARTS HERE
        </div>
      </div>
    </section>
  );
}